import React from "react";
import { Box } from "@mui/material";
import AppBarHeader from "../components/AppBarHeader";

const MainLayout = ({ children }) => (
  <Box
    sx={{
      minHeight: "100vh",
      backgroundColor: "#F8F9FB",
      display: "flex",
      flexDirection: "column",
    }}
  >
    <AppBarHeader title="Weekly Schedule" />

    {/* Full-width content area */}
    <Box
      sx={{
        flexGrow: 1,
        width: "100%",
        px: { xs: 1, md: 2 }, // very small side padding
        py: 1.5,              // small top/bottom padding
      }}
    >
      {children}
    </Box>
  </Box>
);

export default MainLayout;
